<template>
  <div class="nav-bar">
    <div
      class="nav-bar-item"
      v-for="item in menus"
      :class="{ active: currentRoutePath == item.redirectUrl }"
      :key="item.tabId"
      data-io-click="tracker"  @click="handlePath(item.redirectUrl)"
    >
      {{ item.tabName }}
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import course from "@/assets/js/mixin/course";
import qs from "qs";
import { getSchoolBaseTabs } from "@/utils/apis";
export default {
  mixins: [course],
  data() {
    return {
      currentNavIndex: 0,
      menus: [],
    };
  },
  computed: {
    ...mapState(["schoolBaseChildMenu"]),
    currentRoutePath() {
      let path = this.$route.path;
      let length = path.length;
      return path.slice(length - 1) == "/" ? path.slice(0, length - 1) : path;
    },
  },
  watch: {
    $route: {
      async handler(to, from) {
        // console.log("to", to);
      },
      deep: true,
      immediate: true,
    },
  },
  async mounted() {
    let { result } = await getSchoolBaseTabs();
    console.log("result", result);
    this.menus = result || [];
  },
  methods: {
    async handlePath(pathname) {
      if (pathname === "/school-based") {
        let query = await this.queryToSchoolBased();
        //刷新页面
        this.$router.push({
          path: `${pathname}/?${qs.stringify(query)}`,
        });
      } else {
        this.$router.push({
          path: pathname,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.nav-bar {
  height: 56px;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #e6e7e9;
  padding: 0 28px 0;
  display: flex;
  align-items: center;

  .nav-bar-item {
    height: 56px;
    line-height: 56px;
    margin-right: 40px;
    position: relative;
    display: block;
    cursor: pointer;
    // &::after{
    //   position: absolute;
    //   width: 0;
    //   height: 2px;
    //   bottom: 0px;
    //   left: 50%;
    //   background: #0057ff;
    //   animation: lit 0.2s;
    //   // -webkit-transition: all 0.2s;
    //   // transition: all 0.2s;
    //   content: "";
    // }
    &.active {
      color: #0057ff;

      &::after {
        position: absolute;
        width: 0;
        height: 2px;
        bottom: 0px;
        left: 50%;
        background: #0057ff;
        animation: lit 0.2s;
        animation-fill-mode: forwards;
        // -webkit-transition: all 0.2s;
        // transition: all 0.2s;
        content: "";
      }
    }
  }
}
@keyframes lit {
  from {
    left: 50%;
  }

  to {
    width: 100%;
    left: 0;
  }
}
</style>
